import axios from "axios";
import Swal from "sweetalert2";

export const getConversations = async (type, user_agent, page = 1,status) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/conversations`, {
      params: {
        type,
        user_agent,
        page,
    
        status
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};



export const showConversations = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/conversations/${id}`, {
 
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }   
};


export const endConversations = async (postData,id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/conversations/${id}`,postData , {

      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};


   export const deleteConversations = async (id,lang) => {
    const brear = localStorage.getItem("token");
    const result = await Swal.fire({
      title: "هل انت متأكد ؟",
      text: "سيتم الحذف",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Okay",
    });
    if (result.isConfirmed) {
      try {
        const { data } = await axios.delete(`/v1/admin/conversations/${id}`, {
          headers:{
              Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
          }
        
        });
        if (data.success === true) {
          Swal.fire("Deleted!", `${data.message}`, "success");
        } else {
          Swal.fire("Not deleted", `${data.message}`, "info");
        }
        return data;
      } catch (error) {
        throw error;
      }
    }
  };